export function MentionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 4a8 8 0 103.555 15.169 1 1 0 11.89 1.791A9.963 9.963 0 0112 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.296-.317 2.395-.948 3.193A3.197 3.197 0 0118.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1115 8 1 1 0 0117 8v5c0 1.222.85 2 1.5 2 .392 0 .726-.152.984-.478.273-.345.516-.96.516-1.95V12a8 8 0 00-8-8zm3 8a3 3 0 10-6 0 3 3 0 006 0z"
      ></path>
    </svg>
  );
}
